<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Timjam</h1>
          <figure class="image is-4by3">
            <img src="static/images/timjam/timjam_01.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
<p class="title">Timjam is a self-watering ceramic herb pot that consists of two pots and a water container.</p>
          <p>It helps the herbs live longer without
watering them every day. The shape of Timjam is designed for small kitchens and narrow windowsills. You can build your favorite color combination from three separate parts.
</p>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/timjam/timjam_03-highres.jpg" src="static/images/timjam/timjam_03.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/timjam/timjam_02.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/timjam/timjam_04.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default', {
      container: {
        top: 75
      }
    })
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Timjam.vue